
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "alert-notifications",
})
export default class AlertNotifications extends Vue {
  @Prop({ required: false, type: String, default: "de" })
  private readonly locale!: string;

  @Prop({ required: false, type: Number, default: 0 })
  private readonly timeOut!: number;

  @Prop({ required: false, type: Number, default: 3 })
  private readonly limit!: number;

  public onClose() {
    window.dispatchEvent(new CustomEvent("alert-notifications-close"));
  }
  public onOpenHistory() {
    window.dispatchEvent(new CustomEvent("alert-notifications-open-history"));
  }
}
